<div *ngIf="show" style="overflow: auto">
  <svg [attr.width]="width" [attr.height]="height" xmlns="http://www.w3.org/2000/svg">
    <g *ngFor="let gridLine of gridLines">
      <text
        [attr.font-size]="fontSize + 'px'"
        [attr.font-family]="fontFamily"
        [attr.fill]="fontColor"
        [attr.x]="padding + maxRangeValueWidth + 7"
        [attr.y]="gridLine.from.y"
        text-anchor="end"
      >
        <title>{{gridLine.range.value}}</title>
        {{shortNumber(gridLine.range.shortValue)}}
      </text>
      <line stroke="#cdd2d4" stroke-dasharray="2,2" stroke-width="1"
            [attr.x1]="gridLine.from.x" [attr.y1]="gridLine.from.y"
            [attr.x2]="gridLine.to.x" [attr.y2]="gridLine.to.y">
      </line>
      <text [attr.font-size]="fontSize + 'px'" [attr.font-family]="fontFamily" [attr.fill]="fontColor"
            [attr.x]="gridLine.to.x + 15" [attr.y]="gridLine.to.y">
        <title>{{gridLine.range.name}}</title>
        {{shortNumber(gridLine.range.name)}}
      </text>
    </g>
    <g *ngFor="let path of paths">
      <circle *ngIf="path.barDefinition.type=='CIRCLE'"
              [attr.cx]="path.point.x"
              [attr.cy]="path.point.y"
              [attr.stroke]="path.barDefinition.color"
              r="4" stroke-width="3" fill="white">
      </circle>
      <path *ngIf="path.barDefinition.type=='BAR'"
            [attr.fill]="path.barDefinition.color"
            [attr.stroke]="path.barDefinition.color"
            [attr.d]="path.definition">
      </path>
    </g>
    <line *ngFor="let line of lines" stroke="#f2f4f5" stroke-width="1"
          [attr.x1]="line.from.x" [attr.y1]="line.from.y"
          [attr.x2]="line.to.x" [attr.y2]="line.to.y">
    </line>
    <g *ngFor="let name of names" [attr.transform]="'rotate(-90,' + name.point.x + ',' + name.point.y + ')'">
      <text
        [attr.font-size]="fontSize + 'px'"
        [attr.font-family]="fontFamily"
        [attr.fill]="fontColor"
        [attr.x]="name.point.x"
        [attr.y]="name.point.y">
        <title>{{name.name}}</title>
        {{name.name}}
      </text>
    </g>
    <g [attr.transform]="'rotate(-90,' + leftTitle.point.x + ',' + leftTitle.point.y + ')'">
      <text
        [attr.font-size]="(fontSize + 2) + 'px'"
        [attr.font-family]="fontFamily"
        [attr.fill]="fontColor"
        [attr.x]="leftTitle.point.x"
        [attr.y]="leftTitle.point.y">
        <title>{{leftTitle.name}}</title>
        {{leftTitle.name}}
      </text>
    </g>
    <g [attr.transform]="'rotate(90,' + rightTitle.point.x + ',' + rightTitle.point.y + ')'">
      <text
        [attr.font-size]="(fontSize + 2) + 'px'"
        [attr.font-family]="fontFamily"
        [attr.fill]="fontColor"
        [attr.x]="rightTitle.point.x"
        [attr.y]="rightTitle.point.y">
        <title>{{rightTitle.name}}</title>
        {{rightTitle.name}}
      </text>
    </g>
    <g *ngFor="let legendItem of legend">
      <circle *ngIf="legendItem.barDefinition.type=='BAR'"
              [attr.cx]="legendItem.point.x"
              [attr.cy]="legendItem.point.y - fontSize/2 + 2"
              [attr.stroke]="legendItem.barDefinition.color"
              [attr.fill]="legendItem.barDefinition.color"
              r="4" stroke-width="3">
      </circle>
      <circle *ngIf="legendItem.barDefinition.type=='CIRCLE'"
              [attr.cx]="legendItem.point.x"
              [attr.cy]="legendItem.point.y - fontSize/2 + 2"
              [attr.stroke]="legendItem.barDefinition.color"
              r="4" stroke-width="3" fill="white">
      </circle>
      <text
        [attr.font-size]="fontSize + 'px'"
        [attr.font-family]="fontFamily"
        [attr.fill]="fontColor"
        [attr.x]="legendItem.point.x + 15"
        [attr.y]="legendItem.point.y">
        <title>{{legendItem.barDefinition.name}}</title>
        {{legendItem.barDefinition.name}}
      </text>
    </g>
  </svg>
</div>
